import axios from "axios";

const ROOT = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const VENDOR_TOKEN_KEY = "tea_vendor_token";
export const VENDOR_IMP_KEY = "tea_vendor_login_as";  // tab-only: a super admin's Login As session
export const vendorToken = () => sessionStorage.getItem(VENDOR_IMP_KEY) || localStorage.getItem(VENDOR_TOKEN_KEY);

const h = () => { const t = vendorToken(); return t ? { Authorization: `Bearer ${t}` } : {}; };
/** Contract Vendor portal client — vendor-only token, never the staff token. */
export const cvApi = {
  get: (p, params) => axios.get(`${ROOT}/cv/portal${p}`, { headers: h(), params }).then((r) => r.data),
  post: (p, body) => axios.post(`${ROOT}/cv/portal${p}`, body, { headers: h() }).then((r) => r.data),
};
export const cvErr = (e) => {
  const d = e?.response?.data?.detail;
  return typeof d === "string" ? d : Array.isArray(d) ? d.map((x) => x.msg).join("; ") : "Something went wrong. Try again.";
};
export const signOutVendor = () => { if (sessionStorage.getItem(VENDOR_IMP_KEY)) sessionStorage.removeItem(VENDOR_IMP_KEY); else localStorage.removeItem(VENDOR_TOKEN_KEY); };
export const fmtPhone = (p) => { const d = String(p || "").replace(/\D/g, "").slice(-10); return d.length === 10 ? `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}` : p || ""; };
export const money = (n) => `$${Number(n || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
